import {io} from 'socket.io-client';

let socket = null;

export const initSocket = () => {
    if (!socket) {
        socket = io({transports: ['websocket']});
    }

    socket.on('connect', function () {
        const engine = socket.io.engine;
        window.socketId = socket.id;

        console.log('[real-time] Connected as', socket.id);

        for (const i in window.encoded_ids) {
            socket.emit('subscribe', encoded_ids[i]);
            console.log('[real-time] Successfully subscribed to Business channel', encoded_ids[i]);
        }

        engine.once('upgrade', () => {
            console.log('[real-time] The transport was upgraded to', engine.transport.name);
        });

        engine.on('close', (reason) => {
            console.log('[real-time] The underlying connection was closed:', reason);
        });
    });

    socket.io.on('error', (error) => {
        console.log('[real-time] Connection error', error);
    });

    // On disconnect
    socket.on('disconnect', (reason) => {
        if (socket.active) {
            console.log('[real-time] Temporary disconnection, the socket will automatically try to reconnect...', reason);
        } else {
            // the connection was forcefully closed by the server or the client itself
            // in that case, `socket.connect()` must be manually called in order to reconnect
            console.log('[real-time] The connection was forcefully closed:', reason);
        }
    });

    window.addEventListener('beforeunload', () => {
        socket.disconnect();
    });

    // Capture all events from current subscription
    socket.onAny((event, ...args) => {
        console.log(`[real-time] Got event: ${event}`, args);
    });

    return socket;
};

export const getSocket = () => socket;
